import comp from "./AiQuestionGeneratorQuestionDetails";
export default comp;
